'use client';

import classNames from 'classnames';
import { useIntl } from 'react-intl';
import Image from '@alltrails/core/components/Image';
import useWindowSize from '@alltrails/core/hooks/useWindowSize';
import styles from './styles/collageStyles.module.scss';

const mobileWidth = 768;

const NatureUnitesCollage = () => {
  const intl = useIntl();
  const alts = [
    intl.formatMessage({ defaultMessage: 'Two hikers jumping over a small creek one at a time in the middle of a forest' }),
    intl.formatMessage({ defaultMessage: 'An adult and a child hiking over a small red rock' }),
    intl.formatMessage({ defaultMessage: 'Two adults walking their mountain bikes over a small wooden bridge' }),
    intl.formatMessage({ defaultMessage: 'Two adults walking a dog on a leash in a field of rolling hills' }),
    intl.formatMessage({ defaultMessage: 'An adult running on a dirt track with a mountainous field in the background' })
  ];
  const { width } = useWindowSize();

  const getCollageImage = (width: number, height: number | undefined, idx: number, containerClassName?: string, photoWidth?: number) => {
    // eslint-disable-next-line import/no-dynamic-require
    const picJpg = require(`../../assets/images/collage-${photoWidth ? `${photoWidth}w-` : ''}${idx}.avif`);
    return (
      <div className={classNames(containerClassName)}>
        <Image src={picJpg} className={styles.collageImage} alt={alts[idx]} width={width} height={height} />
      </div>
    );
  };

  return (
    <div className={styles.collage}>
      {width < mobileWidth ? (
        <div className={styles.collageCol}>
          {getCollageImage(720, 358, 0, styles.wideImageSmall, 1029)}
          <div className={classNames(styles.collageRow, styles.bottomRow)}>
            {getCollageImage(351, 240, 4, undefined, 503)}
            {getCollageImage(351, 240, 2, undefined, 503)}
          </div>
        </div>
      ) : (
        <>
          <div className={classNames(styles.collageCol, styles.leftCol)}>
            {getCollageImage(720, 358, 0, styles.wideImage)}
            <div className={classNames(styles.collageRow, styles.bottomRow)}>
              {getCollageImage(351, 240, 1, '')}
              {getCollageImage(351, 240, 2, '')}
            </div>
          </div>
          <div className={classNames(styles.collageCol, styles.rightCol)}>
            {getCollageImage(300, 300, 3, '')}
            {getCollageImage(300, 300, 4, '')}
          </div>
        </>
      )}
    </div>
  );
};

export default NatureUnitesCollage;
